<template>
  <div>
    <v-card class="pa-3 mx-5" link elevation="3" :color="color" shaped :to="to">
      <v-row class="ma-1">
        <v-col>
          <v-row justify="center" align="center">
            <span class="white--text display-3">{{data}}</span>
          </v-row>
          <v-row justify="center" align="center">
            <span class="white--text caption">{{ label }}</span>
          </v-row>
        </v-col>
        <v-col>
          <v-row justify="center" align="center" class="ml-5">
            <v-icon dark size="90">{{ icon }}</v-icon>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["data", "label", "icon", "color", "to"]
};
</script>